import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CalendarIntegrationCard = ({ bookingData }) => {
  const { date, time, service } = bookingData || {};

  const formatDateForCalendar = (dateString, timeString) => {
    const dateObj = new Date(dateString);
    const [timeValue, period] = timeString?.split(' ') || [];
    let [hours, minutes] = timeValue?.split(':')?.map(Number) || [0, 0];
    
    if (period === 'PM' && hours !== 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;
    
    dateObj?.setHours(hours, minutes, 0, 0);
    return dateObj;
  };

  const generateGoogleCalendarUrl = () => {
    const startDate = formatDateForCalendar(date, time);
    const endDate = new Date(startDate?.getTime() + 60 * 60 * 1000);
    
    const formatDate = (date) => {
      return date?.toISOString()?.replace(/[-:]/g, '')?.split('.')?.[0] + 'Z';
    };

    const params = new URLSearchParams({
      action: 'TEMPLATE',
      text: `Cute Claw Salon - ${service}`,
      dates: `${formatDate(startDate)}/${formatDate(endDate)}`,
      details: `Your appointment at Cute Claw Salon for ${service}`,
      location: '123 Beauty Lane, Suite 100, Los Angeles, CA 90001'
    });

    window.open(`https://calendar.google.com/calendar/render?${params?.toString()}`, '_blank');
  };

  const generateICalFile = () => {
    const startDate = formatDateForCalendar(date, time);
    const endDate = new Date(startDate?.getTime() + 60 * 60 * 1000);
    
    const formatDate = (date) => {
      return date?.toISOString()?.replace(/[-:]/g, '')?.split('.')?.[0] + 'Z';
    };

    const icalContent = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'BEGIN:VEVENT',
      `DTSTART:${formatDate(startDate)}`,
      `DTEND:${formatDate(endDate)}`,
      `SUMMARY:Cute Claw Salon - ${service}`,
      `DESCRIPTION:Your appointment at Cute Claw Salon for ${service}`,
      'LOCATION:123 Beauty Lane, Suite 100, Los Angeles, CA 90001',
      'END:VEVENT',
      'END:VCALENDAR'
    ]?.join('\r\n');

    const blob = new Blob([icalContent], { type: 'text/calendar' });
    const url = URL.createObjectURL(blob);
    const link = document?.createElement('a');
    link.href = url;
    link.download = 'nailtech-appointment.ics';
    document?.body?.appendChild(link);
    link?.click();
    document?.body?.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="bg-card rounded-xl p-6 border border-border shadow-sm lg:sticky lg:top-24 animate-fade-in">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center">
          <Icon name="CalendarPlus" size={20} color="white" />
        </div>
        <h3 className="font-heading font-semibold text-lg text-foreground">
          Add to Calendar
        </h3>
      </div>

      <p className="text-sm text-muted-foreground font-caption mb-4">
        Never miss your appointment! Add it to your preferred calendar application.
      </p>

      <div className="space-y-3">
        <Button
          onClick={generateGoogleCalendarUrl}
          variant="outline"
          fullWidth
          iconName="Calendar"
        >
          Google Calendar
        </Button>
        
        <Button
          onClick={generateICalFile}
          variant="outline"
          fullWidth
          iconName="Download"
        >
          Apple/Outlook Calendar
        </Button>
      </div>

      <div className="mt-4 p-3 bg-muted/50 rounded-lg border border-border">
        <div className="flex items-start gap-2">
          <Icon name="Bell" size={16} className="text-muted-foreground mt-0.5 flex-shrink-0" />
          <p className="text-xs text-muted-foreground font-caption leading-relaxed">
            We'll send you a reminder 24 hours before your appointment.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CalendarIntegrationCard;